import { dispatch } from '../internal.js';
import * as actionTypes from './actionTypes.js';
export const redirect = (path, options = {}) => {
    if (options.preserveQuery) {
        path = path + window.location.search;
    }
    return dispatch({
        type: actionTypes.REDIRECT,
        payload: { path, replace: options.replace ?? false },
    });
};
//# sourceMappingURL=actions.js.map